import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { DefaultPageSize } from '../../../../core/dto/defaultPage.size';
import { Pagination } from '../../../../core/dto/pagination';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { CategoryService } from '../../../../core/services/category.service';
import { AddEditCategoriesComponent } from '../../../../modules/shared/add-edit-categories/add-edit-categories.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { LoadingService } from '../../../../core/services/loading.service';
import { AppUtils } from '../../../../core/config/app.utils';

@Component({
  selector: 'app-pref-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss'],
})
export class PrefCategoriesComponent implements OnInit {
  pageSize = new DefaultPageSize();
  sortField: any;
  sortOrder: any;
  allCategories: any;
  agentSearch = '';

  sortColumn = {
    compareDate: (a: any, b: any) => {
      return (new Date(b.createdAt) as any) - (new Date(a.createdAt) as any);
    },
    compareName: (a: any, b: any) => a.name.localeCompare(b.name),
  };

  constructor(
    private categoryService: CategoryService,
    private nzModalService: NzModalService,
    private loading: LoadingService,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
    this.getCategoryPaged();
  }

  getCategoryPaged(): void {
    this.loading.start();
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      keyword: this.agentSearch,
    });

    this.categoryService.getAllCategories(payload).then(res => {
      this.allCategories = res.data;
      this.pageSize.length = res.metadata[0]?.total;
      this.loading.stop();
    });
  }

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;

    const currentSort = params.sort.find(item => item.value !== null);
    this.sortField = (currentSort && currentSort.key) || null;
    this.sortOrder =
      (currentSort && AppUtils.getSortOrder(currentSort.value)) || null;
    this.getCategoryPaged();
  }

  onClickAdd(entryType: string, categoryId: any, currentName: string): void {
    this.nzModalService
      .create({
        nzTitle: this.translocoService.translate(
          entryType === 'new'
            ? 'settings.preferences.categories.modal.addTitle'
            : 'settings.preferences.categories.modal.editTitle'
        ),
        nzWidth: '400px',
        nzContent: AddEditCategoriesComponent,
        nzFooter: null,
        nzComponentParams: {
          entryType,
          categoryId,
          currentName,
        },
      })
      .afterClose.subscribe(data => {
        this.getCategoryPaged();
      });
  }

  onClickEdit(entryType: string, categoryId: any, currentName: string): void {
    this.nzModalService
      .create({
        nzTitle: this.translocoService.translate(
          'settings.preferences.categories.modal.editTitle'
        ),
        nzWidth: '400px',
        nzContent: AddEditCategoriesComponent,
        nzFooter: null,
        nzComponentParams: {
          entryType,
          categoryId,
          currentName,
        },
      })
      .afterClose.subscribe(data => {
        this.getCategoryPaged();
      });
  }
}
